export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const LOADING = 'LOADING';
export const SECTIONS = 'SECTIONS';
export const TIMEOUT_MESSAGE = 'TIMEOUT_MESSAGE';